var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.schema.value)?_c('div',{staticClass:"error flex flex-align-center"},[_c('SBIcon',{staticClass:"mr-1",attrs:{"icon":_vm.SBIconList.ERROR,"color":_vm.SBColors.redPrimary,"size":10}}),_c('span',[_vm._v(_vm._s(_vm.schema.value))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }